import $            from 'jquery';
import onePageNav   from '../modules/one_page_nav';


let _activeHash = null;


/**
 * Return a hash fragment from a URL-ish string.
 *
 * @param {String} href Source href attribute value.
 * @returns {(String|null)} Hash fragment including '#' or null when no hash exists.
 */
const _extractHash = (href = '') => {
  const hashIndex = href.indexOf('#');

  return hashIndex === -1 ? null : href.slice(hashIndex);
};


/**
 * Track the clicked hash so focus can be applied once smooth scrolling ends.
 *
 * @param {Event} event Click event object.
 */
const _cacheTargetHash = (event) => {
  _activeHash = _extractHash(event.currentTarget.getAttribute('href'));
};


/**
 * Resolve the current target hash from our click cache or the active nav item.
 *
 * @param {String} [source=_settings.jumpNavSelector] Source element to inspect for active nav item.
 * @returns {(String|null)} Hash fragment including '#', or null when unavailable.
 */
const _resolveTargetHash = (source = _settings.jumpNavSelector) => {
  if (_activeHash) {
    return _activeHash;
  }

  const activeHref = $(source).find('.current a').attr('href');

  return _extractHash(activeHref);
};


/**
 * Focus the destination section heading once jump navigation is complete.
 *
 * @param {String} [source=_settings.jumpNavSelector] Source element to inspect for the active section.
 */
const _focusTargetHeading = (source = _settings.jumpNavSelector) => {
  const hash = _resolveTargetHash(source);

  if (!hash) return;

  const $target = document.querySelector(hash);
  if (!$target) return;

  const $heading = document.querySelector(`${hash}-heading`) || $target.querySelector('h1, h2, h3, h4, h5, h6');
  if (!$heading) return;

  $heading.focus({ preventScroll: true });
  _activeHash = null;
};


/**
 * Bind click tracking for jump-nav links.
 *
 * @param {String} [source=_settings.jumpNavSelector] Source element to listen on.
 */
const _bindHashTracking = (source = _settings.jumpNavSelector) => {

  $(source)
    .off('click.jumpNavHash', 'a')
    .on('click.jumpNavHash', 'a', _cacheTargetHash);

};


/**
 * Resolve the jump nav banner height used for scroll offset.
 *
 * @returns {Number} Height in pixels.
 */
const _getJumpNavOffset = () => {
  return $('.c-jumpNav').outerHeight() || 0;
};


/**
 * Global Settings
 */
const _settings = {
  jumpNavSelector: '.js-jumpNav',
  onePageNavOps: {
    scrollOffset: _getJumpNavOffset,
    end: _focusTargetHeading
  }
};


/**
 * Jump Nav
 *
 * @param {String} [source=_settings.jumpNavSelector] Selector to attach onePageNav to.
 * @param {Object} [ops=_settings.onePageNavOps] onePageNav options object containing all configuration.
 */
const jumpNav = (source = _settings.jumpNavSelector, ops = _settings.onePageNavOps) => {

  _bindHashTracking(source);

  $(source).onePageNav(ops);

};

export default jumpNav;
